import { Modal, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import Switch from "react-switch";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { del, get, post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { IManutencaoFormData, IMaquina } from "../../Interfaces/equipamentos/equipamentos";
import { Modaladdmanutencao } from "./add_manutencao";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";


interface I_aux {
    list_maquina: IMaquina[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list_maquina: React.Dispatch<React.SetStateAction<IMaquina[]>>,
    set_obj_new_maquina: React.Dispatch<React.SetStateAction<IMaquina | undefined>>,
    obj_new_maquina: IMaquina | undefined,

}

export const Modaladdequipamentos: React.FC<I_aux> = ({
    list_maquina,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list_maquina,
    set_obj_new_maquina,
    obj_new_maquina,
}) => {
    const auth = useContext(AuthContext);
    const location = useLocation();


    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [campo_obrigatorio_nome, set_campo_obrigatorio_nome] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);

    const [flag_open_modal_manutencao, set_flag_open_modal_manutencao] = useState<boolean>(false);
    const [flag_open_modal_manutencao_ver_mais, set_flag_open_modal_manutencao_ver_mais] = useState<boolean>(false);
    const [flag_open_modal_manutencao_edit, set_flag_open_modal_manutencao_edit] = useState<boolean>(false);
    const [flag_open_modal_manutencao_add, set_flag_open_modal_manutencao_add] = useState<boolean>(false);
    const [obj_new_manutencao, set_obj_new_manutencao] = useState<IManutencaoFormData>();
    const [lista_de_manutencao, set_lista_de_manutencao] = useState<IManutencaoFormData[]>([]);
    const [error_custo_hora, set_error_custo_hora] = useState<boolean>(false);

    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState<boolean>(false);

    const [hover, setHover] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });

    const [error_valor_aquisicao, set_error_valor_aquisicao] = useState<boolean>(false);
    const [error_consumo_medio_hora, set_error_consumo_medio_hora] = useState<boolean>(false);
    const [error_horimetro_atual, set_error_horimetro_atual] = useState<boolean>(false);
    const [error_proxima_manutencao_horas, set_error_proxima_manutencao_horas] = useState<boolean>(false);  


    const handler_add_maquina = async () => {

        if (obj_new_maquina?.nome === undefined || obj_new_maquina?.nome === '') {
            set_campo_obrigatorio_nome(true)

        } else {

            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, 'api/maquinas/new', {
                    payload: {
                        activo: obj_new_maquina?.activo === undefined ? true : obj_new_maquina?.activo,
                        ano_aquisicao: obj_new_maquina?.ano_aquisicao === undefined ? 0 : obj_new_maquina?.ano_aquisicao,
                        combustivel_tipo: obj_new_maquina?.combustivel_tipo === undefined ? '' : obj_new_maquina?.combustivel_tipo,
                        consumo_medio_hora: obj_new_maquina?.consumo_medio_hora === undefined ? 0 : obj_new_maquina?.consumo_medio_hora.toString().replace(',', '.'),
                        custo_hora: obj_new_maquina?.custo_hora === undefined ? 0 : obj_new_maquina?.custo_hora.toString().replace(',', '.'),
                        estado: obj_new_maquina?.estado === undefined ? '' : obj_new_maquina?.estado,
                        horimetro_atual: obj_new_maquina?.horimetro_atual === undefined ? 0 : obj_new_maquina?.horimetro_atual.toString().replace(',', '.'),
                        id_agri: location.state,
                        inspecao_validade: obj_new_maquina?.inspecao_validade === undefined ? null : obj_new_maquina?.inspecao_validade,
                        marca: obj_new_maquina?.marca === undefined ? '' : obj_new_maquina?.marca,
                        matricula: obj_new_maquina?.matricula === undefined ? '' : obj_new_maquina?.matricula,
                        modelo: obj_new_maquina?.modelo === undefined ? '' : obj_new_maquina?.modelo,
                        nome: obj_new_maquina?.nome === undefined ? '' : obj_new_maquina?.nome,
                        potencia: obj_new_maquina?.potencia === undefined ? '' : obj_new_maquina?.potencia,
                        proxima_manutencao_data: obj_new_maquina?.proxima_manutencao_data === undefined ? null : obj_new_maquina?.proxima_manutencao_data,
                        proxima_manutencao_horas: obj_new_maquina?.proxima_manutencao_horas === undefined ? 0 : obj_new_maquina?.proxima_manutencao_horas,
                        seguro_empresa: obj_new_maquina?.seguro_empresa === undefined ? '' : obj_new_maquina?.seguro_empresa,
                        seguro_apolice: obj_new_maquina?.seguro_apolice === undefined ? '' : obj_new_maquina?.seguro_apolice,
                        seguro_validade: obj_new_maquina?.seguro_validade === undefined ? null : obj_new_maquina?.seguro_validade,
                        tipo: obj_new_maquina?.tipo === undefined ? '' : obj_new_maquina?.tipo,
                        valor_aquisicao: obj_new_maquina?.valor_aquisicao === undefined ? 0 : obj_new_maquina?.valor_aquisicao.toString().replace(',', '.'),
                       
                    }
                });
                if (list_maquina === undefined || list_maquina.length === 0) {
                    set_list_maquina([res.data.result])

                } else {
                    set_list_maquina((old: any) => [...old, res.data.result])

                }
                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_add_maquina", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }
    const handler_edit_maquina = async () => {

        if (obj_new_maquina?.nome === undefined || obj_new_maquina?.nome === '') {
            set_campo_obrigatorio_nome(true)
        } else {


            try {
                setIsLoading(true);
                let res = await put(auth.token.cookie_token, 'api/maquinas/' + obj_new_maquina.id_maquina, {
                    payload: {
                        id_maquina: obj_new_maquina?.id_maquina === undefined ? 0 : obj_new_maquina?.id_maquina,
                        activo: obj_new_maquina?.activo === undefined ? true : obj_new_maquina?.activo,
                        ano_aquisicao: obj_new_maquina?.ano_aquisicao === undefined ? 0 : obj_new_maquina?.ano_aquisicao,
                        combustivel_tipo: obj_new_maquina?.combustivel_tipo === undefined ? '' : obj_new_maquina?.combustivel_tipo,
                        consumo_medio_hora: obj_new_maquina?.consumo_medio_hora === undefined ? 0 : obj_new_maquina?.consumo_medio_hora.toString().replace(',', '.'),
                        custo_hora: obj_new_maquina?.custo_hora === undefined ? 0 : obj_new_maquina?.custo_hora.toString().replace(',', '.'),
                        estado: obj_new_maquina?.estado === undefined ? '' : obj_new_maquina?.estado,
                        horimetro_atual: obj_new_maquina?.horimetro_atual === undefined ? 0 : obj_new_maquina?.horimetro_atual.toString().replace(',', '.'),
                        id_agri: location.state,
                        inspecao_validade: obj_new_maquina?.inspecao_validade === undefined ? null : obj_new_maquina?.inspecao_validade,
                        marca: obj_new_maquina?.marca === undefined ? '' : obj_new_maquina?.marca,
                        matricula: obj_new_maquina?.matricula === undefined ? '' : obj_new_maquina?.matricula,
                        modelo: obj_new_maquina?.modelo === undefined ? '' : obj_new_maquina?.modelo,
                        nome: obj_new_maquina?.nome === undefined ? '' : obj_new_maquina?.nome,
                        potencia: obj_new_maquina?.potencia === undefined ? '' : obj_new_maquina?.potencia,
                        proxima_manutencao_data: obj_new_maquina?.proxima_manutencao_data === undefined ? null : obj_new_maquina?.proxima_manutencao_data,
                        proxima_manutencao_horas: obj_new_maquina?.proxima_manutencao_horas === undefined ? 0 : obj_new_maquina?.proxima_manutencao_horas,
                        seguro_empresa: obj_new_maquina?.seguro_empresa === undefined ? '' : obj_new_maquina?.seguro_empresa,
                        seguro_apolice: obj_new_maquina?.seguro_apolice === undefined ? '' : obj_new_maquina?.seguro_apolice,
                        seguro_validade: obj_new_maquina?.seguro_validade === undefined ? null : obj_new_maquina?.seguro_validade,
                        tipo: obj_new_maquina?.tipo === undefined ? '' : obj_new_maquina?.tipo,
                        valor_aquisicao: obj_new_maquina?.valor_aquisicao === undefined ? 0 : obj_new_maquina?.valor_aquisicao.toString().replace(',', '.'),
                

                    }
                });

                let aux_list = list_maquina.map((el) => {
                    if (el.id_maquina === obj_new_maquina.id_maquina) {
                        return res.data.result
                    } else {
                        return el
                    }
                })

                set_list_maquina(aux_list)


                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_edit_maquina", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)
        if (name === 'custo_hora') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_custo_hora(true)
            } else {
                set_error_custo_hora(false)
            }
        }
        if (name === 'valor_aquisicao') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_valor_aquisicao(true)
            } else {
                set_error_valor_aquisicao(false)
            }
        }
        if (name === 'consumo_medio_hora') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_consumo_medio_hora(true)
            } else {
                set_error_consumo_medio_hora(false)
            }
        }
        if (name === 'horimetro_atual') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_horimetro_atual(true)
            } else {
                set_error_horimetro_atual(false)
            }
        }

        if (name === 'proxima_manutencao_horas') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_proxima_manutencao_horas(true)
            } else {
                set_error_proxima_manutencao_horas(false)
            }
        }
        set_obj_new_maquina((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    }


    const func_reset_all = () => {
        set_obj_new_maquina(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_campo_obrigatorio_nome(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);
        set_error_valor_aquisicao(false);
        set_error_consumo_medio_hora(false);
        set_error_horimetro_atual(false)
        set_error_proxima_manutencao_horas(false)

    }


    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };



    const get_info = async () => {
        try {
            setIsLoading(true);
            let res = await get(auth.token.cookie_token, '/api/maquinas/' + obj_new_maquina?.id_maquina + '/manutencao');

            set_lista_de_manutencao(res.data.result)

            setIsLoading(false);

        } catch (error) {
            func_print("get_info", error, true);
            setIsLoading(false);
        }
    }


    useEffect(() => {
        (async () => {
            if (flag_open_modal_add === false) {
                await get_info();
            }
        })();
    }, []);
    const handle_delete_equipamento = async () => {
        try {
            setIsLoading(true);
            await del(auth.token.cookie_token, `/api/maquinas/${obj_new_maquina?.id_maquina}`);
            list_maquina.splice(list_maquina.findIndex((maquina) => maquina.id_maquina === obj_new_maquina?.id_maquina), 1);
            set_obj_new_maquina(undefined);
            set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
            func_reset_all()
            setMessage(operacao_sucesso);
            setOpenSnackSuccess(true);
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_equipamento", error, true);
            setIsLoading(false);
            if ((error as any)?.response?.data?.message) {
                setMessage((error as any).response.data.message);
            } else {
                setMessage(operacao_erro);
            }
            setOpenSnackError(true);
        }
    }

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >

        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            {
                flag_open_modal_manutencao === true &&
                <Modaladdmanutencao
                    list={lista_de_manutencao}
                    flag_open_modal={flag_open_modal_manutencao}
                    set_flag_open_modal={set_flag_open_modal_manutencao}
                    setMessage={setMessage}
                    setOpenSnackSuccess={setOpenSnackSuccess}
                    setOpenSnackError={setOpenSnackError}
                    set_list={set_lista_de_manutencao}
                    flag_open_modal_ver_mais={flag_open_modal_manutencao_ver_mais}
                    set_flag_open_modal_ver_mais={set_flag_open_modal_manutencao_ver_mais}
                    flag_open_modal_edit={flag_open_modal_manutencao_edit}
                    set_flag_open_modal_edit={set_flag_open_modal_manutencao_edit}
                    flag_open_modal_add={flag_open_modal_manutencao_add}
                    set_flag_open_modal_add={set_flag_open_modal_manutencao_add}
                    set_obj_new={set_obj_new_manutencao}
                    obj_new={obj_new_manutencao}
                    obj_equipamento={obj_new_maquina}
                />
            }
            <div className="flex items-center justify-between w-full p-1 border-b border-gray-100">
                <div></div>

                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                            set_flag_open_modal_add(false)
                        }

                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>

            </div>
            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                            <div className="flex items-center justify-between mt-4 pl-5 w-full mb-4 pr-4">

                                <div className="grid grid-cols gap-2 ">

                                    <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                                        {
                                            flag_open_modal_edit === true ? 'Editar Equipamento' :
                                                flag_open_modal_ver_mais === true ? 'Detalhes do Equipamento' :
                                                    'Adicionar Equipamento'
                                        }

                                    </h2>
                                </div>

                                {
                                    flag_open_modal_add === false && flag_open_modal_edit === false ?

                                        <div className="flex justify-between gap-2">

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_flag_open_modal(true)
                                                    set_flag_open_modal_edit(true)
                                                    set_flag_open_modal_ver_mais(false)
                                                    set_flag_open_modal_add(false)

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <EditIcon sx={{ fontSize: 18 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_open_dialog_tem_a_certeza_que_quer_eliminar(true)

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                            </button>

                                        </div>


                                        : <></>
                                }

                            </div>





                            <div className="flex flex-col gap-6 w-full p-5 rounded-xl bg-gray-50/80">
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Designação</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.nome || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Designação'
                                                            name="nome"
                                                            error={campo_obrigatorio_nome}
                                                            helperText={campo_obrigatorio_nome ? 'Campo obrigatório' : ''}
                                                            value={obj_new_maquina?.nome === undefined ? '' : obj_new_maquina?.nome}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Marca</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.marca || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Marca'
                                                            name="marca"
                                                            value={obj_new_maquina?.marca === undefined ? '' : obj_new_maquina?.marca}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Modelo</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.modelo || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Modelo'
                                                            name="modelo"
                                                            value={obj_new_maquina?.modelo === undefined ? '' : obj_new_maquina?.modelo}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Custo por Hora</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.custo_hora ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Custo por Hora'
                                                            name="custo_hora"
                                                            error={error_custo_hora}
                                                            helperText={error_custo_hora ? 'Insira apenas números' : ''}
                                                            value={obj_new_maquina?.custo_hora === undefined ? '' : obj_new_maquina?.custo_hora}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                </div>
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Matrícula</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.matricula || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Matrícula'
                                                            name="matricula"
                                                            value={obj_new_maquina?.matricula === undefined ? '' : obj_new_maquina?.matricula}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />

                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tipo</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.tipo || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Tipo'
                                                            name="tipo"
                                                            value={obj_new_maquina?.tipo === undefined ? '' : obj_new_maquina?.tipo}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Ano de Aquisição</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.ano_aquisicao || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                minDate={dayjs("2010")}
                                                                views={["year"]}
                                                                label="Ano de Aquisição"
                                                                value={
                                                                    obj_new_maquina?.ano_aquisicao === undefined ||
                                                                        obj_new_maquina?.ano_aquisicao === null ||
                                                                        obj_new_maquina?.ano_aquisicao === 0
                                                                        ? null
                                                                        : dayjs(String(obj_new_maquina?.ano_aquisicao), "YYYY")
                                                                }
                                                                onChange={(newValue) => {
                                                                    set_flag_editado(true);

                                                                    set_obj_new_maquina((old: any) => ({
                                                                        ...old,
                                                                        ano_aquisicao: newValue ? newValue.format("YYYY") : "",
                                                                    }));
                                                                }}
                                                                slots={{
                                                                    textField: (textFieldProps) => (
                                                                        <TextField
                                                                            {...textFieldProps}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            InputLabelProps={{ shrink: true }}
                                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                                        />
                                                                    ),
                                                                }}
                                                            />
                                                        </LocalizationProvider>

                                                    </div>

                                                    : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Valor de Aquisição</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.valor_aquisicao ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Valor de Aquisição'
                                                            name="valor_aquisicao"
                                                            error={error_valor_aquisicao}
                                                            helperText={error_valor_aquisicao ? 'Insira apenas números' : ''}
                                                            value={obj_new_maquina?.valor_aquisicao === undefined ? '' : obj_new_maquina?.valor_aquisicao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>



                                                    : <></>}
                                    </div>
                                </div>
                                {/* row 2: switches */}
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">

                                        <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Ativo</div>

                                        <Switch
                                            height={22}
                                            width={44}
                                            onColor={cores.cor1}
                                            offColor="#e5e7eb"
                                            onChange={() => {

                                                set_flag_editado(true)

                                                set_obj_new_maquina((old: any) => ({
                                                    ...old,
                                                    'activo': !obj_new_maquina?.activo,
                                                }));
                                            }}
                                            checked={obj_new_maquina?.activo ?? false}
                                            disabled={flag_open_modal_ver_mais === true ? true : false}

                                        />

                                    </div>

                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Potência</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.potencia ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Potência'
                                                            name="potencia"
                                                            value={obj_new_maquina?.potencia === undefined ? '' : obj_new_maquina?.potencia}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tipo de Combustível</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.combustivel_tipo ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Tipo de Combustível'
                                                            name="combustivel_tipo"
                                                            value={obj_new_maquina?.combustivel_tipo === undefined ? '' : obj_new_maquina?.combustivel_tipo}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Consumo Médio por Hora</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.consumo_medio_hora ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Consumo Médio por Hora'
                                                            name="consumo_medio_hora"
                                                            error={error_consumo_medio_hora}
                                                            helperText={error_consumo_medio_hora ? 'Insira apenas números' : ''}
                                                            value={obj_new_maquina?.consumo_medio_hora === undefined ? '' : obj_new_maquina?.consumo_medio_hora}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Horimetro Atual</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.horimetro_atual ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Horimetro Atual'
                                                            name="horimetro_atual"
                                                            error={error_horimetro_atual}
                                                            helperText={error_horimetro_atual ? 'Insira apenas números' : ''}
                                                            value={obj_new_maquina?.horimetro_atual === undefined ? '' : obj_new_maquina?.horimetro_atual}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Estado</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.estado ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Estado'
                                                            name="estado"
                                                            value={obj_new_maquina?.estado === undefined ? '' : obj_new_maquina?.estado}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Seguro Empresa</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.seguro_empresa ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Seguro Empresa'
                                                            name="seguro_empresa"
                                                            value={obj_new_maquina?.seguro_empresa === undefined ? '' : obj_new_maquina?.seguro_empresa}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Seguro Apolice</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.seguro_apolice ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Seguro Apolice'
                                                            name="seguro_apolice"
                                                            value={obj_new_maquina?.seguro_apolice === undefined ? '' : obj_new_maquina?.seguro_apolice}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Validade Seguro</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.seguro_validade ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            label='Validade Seguro'
                                                            name="seguro_validade"
                                                            value={obj_new_maquina?.seguro_validade === undefined ? '' : obj_new_maquina?.seguro_validade}
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new_maquina((old: any) => ({
                                                                    ...old,
                                                                    'seguro_validade': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                        {/* <CustomTextField
                                                            variant="outlined"
                                                            label='Validade Seguro'
                                                            name="seguro_validade"
                                                            value={obj_new_maquina?.seguro_validade === undefined ? '' : obj_new_maquina?.seguro_validade}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        /> */}
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Validade Inspeção</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.inspecao_validade ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            label='Validade Inspeção'
                                                            name="inspecao_validade"
                                                            value={obj_new_maquina?.inspecao_validade === undefined ? '' : obj_new_maquina?.inspecao_validade}
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new_maquina((old: any) => ({
                                                                    ...old,
                                                                    'inspecao_validade': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />

                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Horas Próxima Manutenção</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.proxima_manutencao_horas ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Horas Próxima Manutenção'
                                                            name="proxima_manutencao_horas"
                                                            error={error_proxima_manutencao_horas}
                                                            helperText={error_proxima_manutencao_horas ? 'Insira apenas números' : ''}
                                                            value={obj_new_maquina?.proxima_manutencao_horas === undefined ? '' : obj_new_maquina?.proxima_manutencao_horas}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Data da Próxima Manutenção</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_maquina?.proxima_manutencao_data ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            label='Data da Próxima Manutenção'
                                                            name="proxima_manutencao_data"
                                                            value={obj_new_maquina?.proxima_manutencao_data === undefined ? '' : obj_new_maquina?.proxima_manutencao_data}
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new_maquina((old: any) => ({
                                                                    ...old,
                                                                    'proxima_manutencao_data': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}

                                                        />

                                                    </div> : <></>}
                                    </div>
                                </div>
                                {flag_open_modal_ver_mais === true ? <></> :

                                    <div className="flex justify-end w-full pt-4">
                                        <button
                                            type="button"
                                            onClick={() => {


                                                if (obj_new_maquina?.nome === undefined || obj_new_maquina.nome === '') {
                                                    set_campo_obrigatorio_nome(true);
                                                } else {

                                                    set_campo_obrigatorio_nome(false);
                                                    if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                        handler_edit_maquina()
                                                    } else if (flag_open_modal_add === true) {
                                                        handler_add_maquina()
                                                    }
                                                }
                                            }}
                                            className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                        >
                                            Guardar Informação
                                        </button>
                                    </div>
                                }
                            </div>

                            {(flag_open_modal_edit === true || flag_open_modal_ver_mais === true) && flag_open_modal_add === false ? <>
                                <div className="p-5 w-full flex justify-start">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            set_flag_open_modal_manutencao(true)
                                            set_flag_open_modal_manutencao_edit(true)
                                            set_flag_open_modal_manutencao_add(true)
                                            set_obj_new_manutencao(undefined)
                                        }}
                                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                    >
                                        <AddIcon sx={{ fontSize: 18 }} />
                                        Adicionar Registo de Manutenção
                                    </button>
                                </div>

                                {
                                    lista_de_manutencao.length > 0 ?
                                        <div className="p-5 w-full mt-4">
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Registos de Manutenção</div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">

                                                {lista_de_manutencao.map((manutencao, index) => {
                                                    const isSelected = obj_new_manutencao?.id_manutencao === manutencao.id_manutencao;
                                                    const isHovered = hover.flag && hover.id === manutencao.id_manutencao;

                                                    return (

                                                        <div
                                                            key={index}
                                                            className={`
                                                            flex flex-col items-center justify-center w-[200px] min-w-[200px]   p-4 rounded-xl cursor-pointer
                                                            transition-all duration-200
                                                            ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                                            ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                                          `}
                                                            onMouseEnter={() => setHover({ flag: true, id: manutencao.id_manutencao })}
                                                            onMouseLeave={() => setHover({ flag: false, id: manutencao.id_manutencao })}

                                                            onClick={() => {
                                                                set_flag_open_modal_manutencao(true)
                                                                set_obj_new_manutencao(manutencao)
                                                                set_flag_open_modal_manutencao_add(false)
                                                                set_flag_open_modal_manutencao_ver_mais(true)
                                                                set_flag_open_modal_manutencao_edit(false)
                                                            }}
                                                        >
                                                            <div className="space-y-2 text-sm">
                                                                <div className="flex items-center justify-between gap-3">
                                                                    <span className="text-gray-500">Descrição</span>
                                                                    <span className="text-gray-800 font-medium break-words">
                                                                        {manutencao.descricao || '-'}
                                                                    </span>
                                                                </div>
                                                                <div className="flex items-center justify-between gap-3">
                                                                    <span className="text-gray-500">Data</span>
                                                                    <span className="text-gray-800 font-medium break-words">
                                                                        {manutencao.data || '-'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div> : null
                                }
                            </>
                                : null
                            }
                        </div>
                    </>
            }

            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />

            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                onConfirm={handle_delete_equipamento}
                message="Deseja eliminar o registo?"
            />
        </div>



    </Modal>)

}
